import { fetchTolls } from './search/fetchTolls';
import { combineEpics } from 'redux-observable';
import { getCompanyMetadata } from './direct-offers/companyMetadata';
import { setProfileSettings } from './profile/profileSettings';
import { getCompanyInformation } from './direct-offers/companyInfo';
import { getCompanyStatus } from './direct-offers/getCompanyStatus';
import { getCompanyInformationPlusStatus } from './direct-offers/companyInfoPlusStatus';

export default combineEpics(fetchTolls, getCompanyMetadata, setProfileSettings, getCompanyInformation, getCompanyStatus, getCompanyInformationPlusStatus);
